import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_left_line",
  "use": "icon-icon_general_left_line-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_general_left_line\">\n<polygon points=\"38,23 13.8000002,23 21.7000008,15.1999998 20.2999992,13.6999998 10,24 20.2999992,34.2999992 \n\t21.7000008,32.7999992 13.8000002,25 38,25 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol